// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/billableCustomer.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (P0 2026-10-06: ONE "vendors/subcontractors are not customers" rule, client + server.)
//
// Side-effect module: attaches `window.BillableCustomer`. Every customer
// picker / matcher filters through it; vendor-facing views (AP, CRM Vendors,
// expenses, 1099) do not.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  /** customers-collection `type` values that are NOT customers (we pay them). */
  var NON_CUSTOMER_TYPES = ['vendor', 'subcontractor'];

  /** Normalized type: '' when missing. */
  function customerDocType(c) {
    if (!c || c.type === undefined || c.type === null) return '';
    return String(c.type).trim().toLowerCase();
  }

  /** true = vendor / subcontractor (someone we pay), never offered as a customer. */
  function isVendorLikeCustomer(c) {
    return NON_CUSTOMER_TYPES.indexOf(customerDocType(c)) >= 0;
  }

  /** true = a customer we can bill. Missing type = customer (legacy docs). */
  function isBillableCustomer(c) {
    if (!c || typeof c !== 'object') return false;
    return !isVendorLikeCustomer(c);
  }

  /**
   * Filter a customers list down to billable customers. `keepId` (string or
   * array of strings) names docs that must survive even when they are vendors —
   * the value a record is ALREADY pointing at. Input order is kept.
   */
  function billableCustomers(list, keepId) {
    var keep = keepId === undefined || keepId === null ? [] : (Array.isArray(keepId) ? keepId : [keepId]);
    var keepSet = {};
    for (var i = 0; i < keep.length; i++) {
      if (keep[i] !== undefined && keep[i] !== null && keep[i] !== '') keepSet[String(keep[i])] = true;
    }
    var out = [];
    var arr = Array.isArray(list) ? list : [];
    for (var j = 0; j < arr.length; j++) {
      var c = arr[j];
      if (!c || typeof c !== 'object') continue;
      if (isBillableCustomer(c) || (c.id !== undefined && c.id !== null && keepSet[String(c.id)] === true)) out.push(c);
    }
    return out;
  }

  // -----------------------------------------------------------------------------
  // TASK-9684 — ACCOUNT VENDORS vs OTHER PAYEES (Chris decided 2026-10-05).
  // QuickBooks makes every card/bank payee a Vendor (TITS: 306 vendors, bills
  // from 54). DispatchDeck keeps every vendor-like doc but SHOWS them split by
  // how they are paid, DERIVED from activity, never a manual tag:
  //   'account' — an account vendor: sends bills (a DD AP bill, or QuickBooks
  //               counted Bills > 0 in qboActivity), OR is a subcontractor, OR is
  //               marked 1099 (a real 1099-NEC payee is never folded away).
  //   'payee'   — card/bank only, or no bill activity yet ("Other payees").
  //   ''        — not vendor-like (a customer); never in either list.
  // A payee moves up by itself on its first bill. A hand-added vendor with no
  // qboActivity is judged on DD bills alone; a QuickBooks-IMPORTED one with no
  // qboActivity yet (the 10/05 TITS import) is 'account' until a re-run stamps it.
  // The escape hatch is VIEW-ONLY and never changes a record:
  //   opts.showAll — "Show all payees as vendors" (tenant setting): every
  //                  vendor-like doc is in the default list.
  //   opts.pins    — ids pinned to the short list (tenant setting).
  //   opts.keepId  — ids a record already points at (an AP bill's vendor):
  //                  kept in the default list so a Save never re-points it.
  // opts.billVendorIds — ids with at least one DD AP bill (array or {id:true}).
  // -----------------------------------------------------------------------------

  /** array | {id:true} | single id -> {id:true}. Anything else -> {}. */
  function vendorIdSet(x) {
    var out = {};
    if (x === undefined || x === null || x === '') return out;
    if (Array.isArray(x)) {
      for (var i = 0; i < x.length; i++) {
        if (x[i] !== undefined && x[i] !== null && x[i] !== '') out[String(x[i])] = true;
      }
      return out;
    }
    if (typeof x === 'object') {
      for (var k in x) {
        if (Object.prototype.hasOwnProperty.call(x, k) && x[k] === true) out[k] = true;
      }
      return out;
    }
    out[String(x)] = true;
    return out;
  }

  /** true = QuickBooks counted at least one Bill from this vendor (TASK-9611 qboActivity stamp). */
  function hasQboBillActivity(c) {
    var a = c && c.qboActivity;
    if (!a || typeof a !== 'object') return false;
    var n = Number(a.bills);
    return isFinite(n) && n > 0;
  }

  /** true = a QuickBooks-imported vendor doc with no qboActivity stamp yet (how it is paid is unknown). */
  function vendorActivityUnknown(c) {
    if (!c || typeof c !== 'object' || c.importedFrom !== 'qbo') return false;
    var a = c.qboActivity;
    return !(a && typeof a === 'object' && !Array.isArray(a));
  }

  /**
   * 'account' | 'payee' for a vendor-like doc, '' for anything else.
   * Pins and showAll do NOT change the kind — they only change what is shown.
   */
  function vendorPayeeKind(c, opts) {
    if (!c || typeof c !== 'object' || !isVendorLikeCustomer(c)) return '';
    if (customerDocType(c) === 'subcontractor') return 'account';
    if (c.is1099 === true) return 'account';
    // COD Domain round 3: a W-9 on file = a 1099 relationship (a check/ACH-paid hauler) — never fold it.
    if (c.w9OnFile === true) return 'account';
    if (hasQboBillActivity(c)) return 'account';
    // Imported from QuickBooks BEFORE the import stamped qboActivity (the 10/05
    // TITS run): how it is paid is UNKNOWN, so it is never folded away (COD
    // Domain/Blast 2026-10-07 — day one must not bury ~54 real bill senders).
    // A QuickBooks setup -> Vendors re-run stamps qboActivity and splits it.
    if (vendorActivityUnknown(c)) return 'account';
    var bills = vendorIdSet(opts && opts.billVendorIds);
    if (c.id !== undefined && c.id !== null && bills[String(c.id)] === true) return 'account';
    return 'payee';
  }

  /** true = this vendor-like doc is in the DEFAULT vendor list (CRM Vendors, AP picker). */
  function isShortListVendor(c, opts) {
    var kind = vendorPayeeKind(c, opts);
    if (!kind) return false;
    if (kind === 'account') return true;
    if (opts && opts.showAll === true) return true;
    if (c.id === undefined || c.id === null) return false;
    var id = String(c.id);
    return vendorIdSet(opts && opts.pins)[id] === true || vendorIdSet(opts && opts.keepId)[id] === true;
  }

  /**
   * Split a customers list into { vendors, payees } (vendor-like docs only,
   * input order kept). `vendors` = the default list; `payees` = "Other payees".
   * With opts.showAll every vendor-like doc is in `vendors` and `payees` is [].
   */
  function splitVendorsAndPayees(list, opts) {
    var out = { vendors: [], payees: [] };
    var arr = Array.isArray(list) ? list : [];
    for (var i = 0; i < arr.length; i++) {
      var c = arr[i];
      if (!c || typeof c !== 'object' || !isVendorLikeCustomer(c)) continue;
      if (isShortListVendor(c, opts)) out.vendors.push(c); else out.payees.push(c);
    }
    return out;
  }

  /**
   * The vendor ids that have at least one DD AP bill, from apInvoices docs
   * ({ vendorId, source }). Bank-reconciliation rows are card charges, not
   * bills, and never count (they carry vendorId null today; checked anyway).
   */
  function billVendorIdsFromInvoices(invoices) {
    var out = {};
    var arr = Array.isArray(invoices) ? invoices : [];
    for (var i = 0; i < arr.length; i++) {
      var inv = arr[i];
      if (!inv || typeof inv !== 'object') continue;
      if (inv.source === 'reconciliation') continue;
      var v = inv.vendorId;
      if (v === undefined || v === null || v === '') continue;
      out[String(v)] = true;
    }
    return out;
  }

  window.BillableCustomer = Object.freeze({
    NON_CUSTOMER_TYPES: Object.freeze(NON_CUSTOMER_TYPES.slice()),
    customerDocType: customerDocType,
    isVendorLikeCustomer: isVendorLikeCustomer,
    isBillableCustomer: isBillableCustomer,
    billableCustomers: billableCustomers,
    vendorIdSet: vendorIdSet,
    hasQboBillActivity: hasQboBillActivity,
    vendorActivityUnknown: vendorActivityUnknown,
    vendorPayeeKind: vendorPayeeKind,
    isShortListVendor: isShortListVendor,
    splitVendorsAndPayees: splitVendorsAndPayees,
    billVendorIdsFromInvoices: billVendorIdsFromInvoices
  });
})();
